export const LINK_KEY_OVERVIEW = 'overview';
export const LINK_KEY_PRICING = 'pricing';
export const LINK_KEY_PHOTOS = 'photos';
export const LINK_KEY_RESEARCH = 'research';
export const LINK_KEY_REVIEWS = 'reviews';
export const LINK_KEY_SPECS = 'specs';
export const LINK_KEY_FEATURES = 'features';
export const LINK_KEY_SIMILAR = 'similar';
export const LINK_KEY_ACCESSORIES = 'accessories';
export const LINK_KEY_PROMO = 'promo';
export const LINK_KEY_COMPARE = 'compare';
